export var HISCOX_PI_DECLARATION = 'hiscox_pi_declaration';
export var HISCOX_PL_DECLARATION = 'hiscox_pl_declaration';
export var HISCOX_BOP_DECLARATION = 'hiscox_bop_declaration';
export var HISCOX_CYBER_DECLARATION = 'hiscox_cyber_declaration';